// 解决权限问题
// 解决激活刷新问题
// 解决菜单分组问题 ok
// 每个页面都都左边菜单配置，方便统计管理，以及整体布局的调整以及优化 ok
const routes = [
    {
        path: "/rhqy",
        redirect: "rhqy/login"
    },
    // {
    //   path: "/rhqy/login",
    //   name: "rhqyLogin",
    //   component: () => import("../Login.vue")
    // },
    {
        path: "/rhqy/login",
        name: "rhqyloginAccout",
        component: () => import("../LoginAccout.vue")
    },
    {
        path: "/rhqy/privacyAgreement",
        name: "rhqyPrivacyAgreement",
        component: () => import("../privacyAgreement.vue")
    },
    {
        path: "/rhqy/userAgreement",
        name: "rhqyUserAgreement",
        component: () => import("../userAgreement.vue")
    },
    {
        path: "/rhqy/exportAppointmentData",
        name: "rhqyExportAppointmentData",
        component: () => import("../ExportAppointmentData.vue")
    },
    {
        path: "/rhqy/lyout",
        name: "rhqyLyout",
        component: () => import("../Lyout.vue"),
        meta: {
            // keepAlive: true
        },
        children: [
            // 没有左菜单部分
            {
                path: "/rhqy/lyoutNn",
                name: "rhqyLyoutNn",
                component: () => import("../LyoutNn.vue"),
                meta: {
                    // keepAlive: true
                },
                children: [
                    {
                        path: "/rhqy/home",
                        redirect: "/rhqy/home/view"
                    },
                    {
                        path: "/rhqy/home/view",
                        name: "rhqyHomeView",
                        component: () => import("../ReportMain.vue"),
                        meta: {
                            // 是否显示底部Copyright
                            showFoot: true
                        }
                    },
                    {
                        path: "/rhqy/member",
                        redirect: "/rhqy/member/view"
                    },
                    {
                        path: "/rhqy/member/view",
                        name: "rhqyMemberView",
                        component: () => import("../MemberNew.vue"),
                        meta: {}
                    },
                    {
                        path: "/rhqy/privilege",
                        redirect: "/rhqy/privilege/view"
                    },
                    {
                        path: "/rhqy/privilege/view",
                        name: "rhqyPrivilegeView",
                        component: () => import("../Privilege/index.vue"),
                        meta: {}
                    },
                    {
                        path: "/rhqy/privilege/view/edit/:id?",
                        name: "rhqyPrivilegeViewEdit",
                        component: () => import("../Privilege/groupEdit.vue"),
                        meta: {}
                    },
                    {
                        path: "/rhqy/accout/view",
                        name: "rhqyAccoutView",
                        component: () => import("../Accout.vue"),
                        meta: {}
                    },
                    {
                        path: "/rhqy/accout/logout",
                        name: "rhqyAccoutLogout",
                        component: () => import("../Logout.vue"),
                        meta: {}
                    }
                ]
            },
            // 业务管理
            {
                path: "/rhqy/service",
                name: "rhqyLyoutYw",
                component: () => import("../LyoutYw.vue"),
                meta: {
                    showLeftAside: true
                    // keepAlive: true
                },
                children: [
                    // 基地管理
                    {
                        path: "/rhqy/service/basic/base",
                        name: "rhqyServiceBase",
                        component: () => import("../BasicManage/base.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 基地坐标管理
                    {
                        path: "/rhqy/service/basic/coordinate",
                        name: "rhqyServiceCoordinate",
                        component: () => import("../BasicManage/coordinate.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 门岗管理
                    {
                        path: "/rhqy/service/truck/GateManage",
                        name: "rhqyServiceTruckGateManage",
                        component: () => import("../SafetyRelease/GateManage.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 预约业务管理（新）
                    {
                        path: "/rhqy/service/basic/serviceList",
                        name: "rhqyServiceList",
                        component: () => import("../BasicManage/serviceList.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 车辆业务类型管理
                    {
                        path: "/rhqy/service/basic/businessList",
                        name: "rhqyServiceBusinessList",
                        component: () => import("../BasicManage/businessList.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 货物种类管理
                    {
                        path: "/rhqy/service/basic/goodsType",
                        name: "rhqyServiceGoodsType",
                        component: () => import("../BasicManage/goodsType.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 取样点
                    {
                        path: "/rhqy/service/basic/samplePoint",
                        name: "rhqyServiceSamplePoint",
                        component: () => import("../BasicManage/samplePoint.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    // 取样点详情
                    {
                        path: "/rhqy/service/basic/samplePointDetail/:id",
                        name: "rhqyServiceSamplePointDetail",
                        component: () => import("../BasicManage/samplePointDetail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: "/rhqy/service/basic/samplePoint"
                        }
                    },
                    // 装卸点
                    {
                        path: "/rhqy/service/basic/warehouse",
                        name: "rhqyServiceWarehouse",
                        component: () => import("../BasicManage/warehouse.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    // 装卸点详情
                    {
                        path: "/rhqy/service/basic/warehouseDetail/:id",
                        name: "rhqyServiceWarehouseDetail",
                        component: () => import("../BasicManage/warehouseDetail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: "/rhqy/service/basic/warehouse"
                        }
                    },
                    // 安全告知书
                    {
                        path: "/rhqy/service/safe/notice",
                        name: "rhqyServiceSafeNotice",
                        component: () => import("../Notice/SafeNotice.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 进厂指引
                    {
                        path: "/rhqy/service/basic/guide",
                        name: "rhqyServiceGuide",
                        component: () => import("../BasicManage/guide.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 北斗接口配置
                    {
                        path: "/rhqy/service/basic/beidouApiConfig",
                        name: "rhqyServiceBeidouApiConfig",
                        component: () => import("../BasicManage/beidouApiConfig.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/basic/companyPoundSystemConfig",
                        name: "rhqyServiceCompanyPoundSystemConfig",
                        component: () => import("../BasicManage/companyPoundSystemConfig.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/basic/companyC3Config",
                        name: "rhqyServiceCompanyC3Config",
                        component: () => import("../BasicManage/companyC3Config.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/basic/bookingStrandedWarning",
                        name: "rhqyServiceBookingStrandedWarning",
                        component: () => import("../BasicManage/bookingStrandedWarning.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/basic/autoCallingSchedule",
                        name: "rhqyServiceAutoCallingSchedule",
                        component: () => import("../BasicManage/autoCallingSchedule.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/appoint/timeTplList", // 预约时间模板
                        name: "rhqyServiceAppointTimeTplList",
                        component: () => import("../AppointManage/TimeTplList.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    {
                        path: "/rhqy/service/appoint/timeTplList/addAndEdit/:id?", // 新建/编辑预约时间模板
                        name: "rhqyServiceAppointTimeTplModify",
                        component: () => import("../AppointManage/TimeTplModify.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/appoint/timeTplList/detail/:id?", // 查看模板详情
                        name: "rhqyServiceAppointTimeTplDetail",
                        component: () => import("../AppointManage/TimeTplDetail.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/appoint/timeCaseList", // 预约时间实例
                        name: "rhqyServiceAppointTimeCaseList",
                        component: () => import("../AppointManage/TimeCaseList.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    {
                        path: "/rhqy/service/appoint/timeCaseList/detail/:id?", // 查看实例详情
                        name: "rhqyServiceAppointTimeCaseDetail",
                        component: () => import("../AppointManage/TimeCaseDetail.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/appoint/timeCaseList/modify/:id?", // 修改实例号源
                        name: "rhqyServiceAppointTimeCaseModify",
                        component: () => import("../AppointManage/TimeCaseModify.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/entryAuth", // 车辆业务授权管理
                        name: "rhqyServiceEntryAuth",
                        component: () => import("../EntryAuth.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/callingManage", // 叫号关联
                        name: "rhqyServiceCallingManage",
                        component: () => import("../Calling.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/clockIn/ClockList", // 发货打卡记录
                        name: "rhqyServiceClockList",
                        component: () => import("../ClockManage/ClockList.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/clockIn/CheckMonitor", // 打卡监控
                        name: "rhqyServiceCheckMonitor",
                        component: () => import("../ClockManage/CheckMonitor.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/clockIn/ClockDetail/:pageType/:id", // 发货打卡记录详情
                        name: "rhqyServiceClockDetail",
                        component: () => import("../ClockManage/ClockDetail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: "/rhqy/service/clockIn/ClockList"
                        }
                    },
                    {
                        path: "/rhqy/service/clockIn/VehicleReport", // 车辆报备管理
                        name: "rhqyServiceVehicleReport",
                        component: () => import("../ClockManage/VehicleReport.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/clockIn/VehicleReportDetail/:id", // 车辆报备详情
                        name: "rhqyServiceVehicleReportDetail",
                        component: () => import("../ClockManage/VehicleReportDetail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: "/rhqy/service/clockIn/VehicleReport"
                        }
                    },
                    {
                        path: "/rhqy/service/clockIn/CollectionForm", // 预约送货收集表管理
                        name: "rhqyServiceCollectionForm",
                        component: () => import("../ClockManage/CollectionForm.vue"),
                        meta: {
                            keepAlive: true,
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/AppointDeliveryRecord/List", // 预约送货记录列表
                        name: "rhqyServiceAppointDeliveryRecordList",
                        component: () => import("../AppointDelivery/DeliveryRecord.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    {
                        path: "/rhqy/service/AppointDeliveryRecord/Detail/:booking_info_id", // 预约送货记录详情
                        name: "rhqyServiceAppointDeliveryRecordDetail",
                        component: () => import("../AppointDelivery/DeliveryRecordDetail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: '/rhqy/service/AppointDeliveryRecord/List'
                        }
                    },
                    {
                        path: "/rhqy/service/AppointPickup/List", // 预约提货记录列表
                        name: "rhqyServiceAppointPickupList",
                        component: () => import("../AppointPickup/PickUpRecord.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    {
                        path: "/rhqy/service/AppointPickup/Detail/:booking_info_id", // 预约提货记录详情
                        name: "rhqyServiceAppointPickupDetail",
                        component: () => import("../AppointPickup/PickUpRecordDetail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: '/rhqy/service/AppointPickup/List'
                        }
                    },
                    {
                        path: "/rhqy/service/WeighConfirmManage/List", // 过磅确认管理
                        name: "rhqyServiceWeighConfirmManageList",
                        component: () => import("../WeighConfirmManage/List.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    {
                        path: "/rhqy/service/WeighConfirmManage/Detail/:id", // 过磅确认管理详情
                        name: "rhqyServiceWeighConfirmManageDetail",
                        component: () => import("../WeighConfirmManage/Detail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: "/rhqy/service/WeighConfirmManage/List"
                        }
                    },
                    {
                        path: "/rhqy/service/AccessCard/Send",
                        name: "rhqyServiceAccessCardSend",
                        component: () => import("../AccessCard/Send.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/service/AccessCard/Return",
                        name: "rhqyServiceAccessCardReturn",
                        component: () => import("../AccessCard/Return.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 收样核对
                    {
                        path: "/rhqy/service/ReceiveSampleCollate",
                        name: "rhqyServiceReceiveSampleCollate",
                        component: () => import("../ReceiveSampleCollate.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 投诉建议
                    {
                        path: "/rhqy/service/Complaint/List",
                        name: "rhqyServiceComplaintList",
                        component: () => import("../Complaint/List.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 投诉建议详情
                    {
                        path: "/rhqy/service/Complaint/Detail/:id",
                        name: "rhqyServiceComplaintDetail",
                        component: () => import("../Complaint/Detail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: '/rhqy/service/Complaint/List'
                        }
                    },
                    // 价格管理
                    {
                        path: "/rhqy/service/PriceManage/nowPrice",
                        name: "rhqyServicePriceManageNowPrice",
                        component: () => import("../PriceManage/nowPrice.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 铁路大票管理
                    {
                        path: "/rhqy/service/RailwayTicketManage",
                        name: "rhqyServiceRailwayTicketManage",
                        redirect: "/rhqy/service/RailwayTicketManage/region"
                    },
                    // 铁路大票管理二级菜单共用页面组件，由路由 meta 指定当前业务页。
                    {
                        path: "/rhqy/service/RailwayTicketManage/region",
                        name: "rhqyServiceRailwayTicketRegionPrice",
                        component: () => import("../RailwayTicketManage.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true,
                            activeTab: "region",
                            pageTitle: "铁路区域定价"
                        }
                    },
                    {
                        path: "/rhqy/service/RailwayTicketManage/factory",
                        name: "rhqyServiceRailwayTicketFactoryPrice",
                        component: () => import("../RailwayTicketManage.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true,
                            activeTab: "factory",
                            pageTitle: "铁路专厂价格"
                        }
                    },
                    {
                        path: "/rhqy/service/RailwayTicketManage/collect",
                        name: "rhqyServiceRailwayTicketCollect",
                        component: () => import("../RailwayTicketManage.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true,
                            activeTab: "collect",
                            pageTitle: "铁路大票收集表"
                        }
                    },
                    {
                        path: "/rhqy/service/RailwayTicketManage/prepayRatio",
                        name: "rhqyServiceRailwayTicketPrepayRatio",
                        redirect: "/rhqy/service/RailwayTicketManage/collect"
                    },
                    {
                        path: "/rhqy/service/RailwayTicketManage/prepay",
                        name: "rhqyServiceRailwayTicketPrepay",
                        redirect: "/rhqy/service/RailwayTicketManage/collect"
                    },
                    {
                        path: "/rhqy/service/RailwayTicketManage/statement",
                        name: "rhqyServiceRailwayTicketStatement",
                        redirect: "/rhqy/service/RailwayTicketManage/collect"
                    },
                    // 安全告知书
                    {
                        path: "/rhqy/service/announcement",
                        name: "rhqyServiceAnnouncement",
                        component: () => import("../Notice/Announcement.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 操作日志
                    {
                        path: "/rhqy/service/oplog",
                        name: "rhqyServiceOplog",
                        component: () => import("../Oplog.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    // 供应商评估表
                    {
                        path: "/rhqy/service/report/SupplierEvaluation",
                        name: "rhqyServiceReportSupplierEvaluation",
                        component: () => import("../ReportManage/SupplierEvaluation.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    // 木片打卡统计表
                    {
                        path: "/rhqy/service/report/ChipClockInStatistics",
                        name: "rhqyServiceReportChipClockInStatistics",
                        component: () => import("../ReportManage/ChipClockInStatistics.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    // 木片送货情况日报
                    {
                        path: "/rhqy/service/report/ChipDeliverGoodsDailyPaper",
                        name: "rhqyServiceReportChipDeliverGoodsDailyPaper",
                        component: () => import("../ReportManage/ChipDeliverGoodsDailyPaper.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    // 质检明细表
                    {
                        path: "/rhqy/service/report/InspectionDetail",
                        name: "rhqyServiceReportInspectionDetail",
                        component: () => import("../ReportManage/InspectionDetail.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    // 装卸点车辆排队情况统计
                    {
                        path: "/rhqy/service/report/WarehouseQueue",
                        name: "rhqyServiceReportWarehouseQueue",
                        component: () => import("../ReportManage/WarehouseQueue.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    // 车辆嫌疑名单
                    {
                        path: "/rhqy/service/SuspectVehicleList",
                        name: "rhqyServiceSuspectVehicleList",
                        component: () => import("../SuspectVehicle/List.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                    // 其他设置
                    {
                        path: "/rhqy/service/other",
                        name: "rhqyServiceOtherManage",
                        component: () => import("../OtherManage.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true
                        }
                    },
                ]
            },
            //应用设置
            {
                path: "/rhqy/yyManege",
                name: "rhqyLyoutYy",
                component: () => import("../LyoutYy.vue"),
                meta: {
                    showLeftAside: true
                },
                children: [
                    {
                        path: "/rhqy/yyManege/carAppoint/:id?",
                        name: "rhqyYyManegeCarAppoint",
                        component: () => import("../AppManege/CarAppoint.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    }
                ]
            },
            // 组织架构
            {
                path: "/rhqy/org",
                name: "rhqyLyoutOrg",
                component: () => import("../LyoutOrg.vue"),
                meta: {
                    showLeftAside: true
                },
                children: [
                    {
                        path: "/rhqy/org/member",
                        name: "rhqyOrgMember",
                        component: () => import("../MemberNew.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/org/label",
                        name: "rhqyOrgLabel",
                        component: () => import("../Label.vue"),
                        meta: {
                            showLeftAside: true,
                        }
                    },
                    // 用户管理
                    {
                        path: "/rhqy/org/user",
                        name: "rhqyOrgUser",
                        component: () => import("../UserManage/index.vue"),
                        meta: {
                            showLeftAside: true,
                            keepAlive: true,
                            role_id: ""
                        }
                    },
                    // 用户管理详情页
                    {
                        path: "/rhqy/org/userDetail/:recordId/:pageType",
                        name: "rhqyOrgUserDetail",
                        component: () => import("../UserManage/detail.vue"),
                        meta: {
                            showLeftAside: true,
                            activeMenu: "/rhqy/org/user"
                        }
                    },
                ]
            },
            // 权限管理
            {
                path: "/rhqy/pri",
                name: "rhqyLyoutPri",
                component: () => import("../LyoutPri.vue"),
                meta: {
                    showLeftAside: true
                },
                children: [
                    {
                        path: "/rhqy/pri/app/index",
                        name: "rhqyPriApp",
                        component: () => import("../Privilege/index.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    },
                    {
                        path: "/rhqy/pri/app/index/edit/:code?/:id?",
                        name: "rhqyPriAppEdit",
                        component: () => import("../Privilege/groupEdit.vue"),
                        meta: {showLeftAside: true}
                    },
                    {
                        path: "/rhqy/pri/admin",
                        name: "rhqyOrgLabelAdmin",
                        component: () => import("../Privilege/admin.vue"),
                        meta: {
                            showLeftAside: true
                        }
                    }
                ]
            }
        ]
    }
];
export default routes;
